import { render, staticRenderFns } from "./TaxInItem.vue?vue&type=template&id=f976c8be&scoped=true&"
import script from "./TaxInItem.vue?vue&type=script&lang=js&"
export * from "./TaxInItem.vue?vue&type=script&lang=js&"
import style0 from "./TaxInItem.vue?vue&type=style&index=0&id=f976c8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f976c8be",
  null
  
)

export default component.exports